import { Inject, Component, Input, ChangeDetectorRef } from "@angular/core";
import { GlobalSettings, GraphicsPanel } from "../../../shared/models";
import { GlobalDataStore } from "../../../shared/providers/globalData";
import { AbstractPopupComponent } from "../../../../shared/components/popup/abstractPopupComponent";
import { PopupIdentifiers } from "../../providers";

@Component({
  selector: 'graphics-popup',
  templateUrl: './graphicsPopupComponent.html'
})
export class GraphicsPopupComponent extends AbstractPopupComponent {

  public id: string = PopupIdentifiers.Graphics;

  public panel: GraphicsPanel;

  public configurationId: number;
  public confSessionId: number;

  constructor(
    @Inject(GlobalDataStore) public globalDataStore: GlobalDataStore,
    public cdr: ChangeDetectorRef
  ) {
    super(cdr);
  }

  show(panel: GraphicsPanel, configurationId = null, confSessionId = null): void {
    this.panel = panel;

    this.configurationId = configurationId;
    this.confSessionId = confSessionId;

    this.showInternal();
  }

  update(): void {
  }

  public get globalSettings(): GlobalSettings {
    return this.globalDataStore.getGlobalData().globalSettings;
  }

}